import React from 'react';

import { IconButton } from '@stockx/ui';
import { ChevronLeftIcon, CloseIcon, Wordmark } from '@stockx/icons';
import useUrlPrefix from '@app/hooks/useUrlPrefix';
import { useTranslation } from 'react-i18next';
import { NavHeader, NavHeaderImgWrapper } from './Header.styles';

type HeaderProps = {
  showBack?: boolean;
  handleOnClick: (props) => void;
};
const Header = ({ showBack = false, handleOnClick }: HeaderProps) => {
  const urlPrefix = useUrlPrefix();
  const { t } = useTranslation();

  return (
    <NavHeader>
      {showBack ? (
        <IconButton
          aria-label={t('Back')}
          padding="0"
          marginLeft="-5px"
          icon={<ChevronLeftIcon boxSize="6" />}
          onClick={handleOnClick}
        />
      ) : (
        <div className="nav-close">
          <IconButton
            aria-label={t('Close')}
            padding="0"
            marginLeft="-5px"
            icon={<CloseIcon boxSize="6" />}
            onClick={handleOnClick}
          />
        </div>
      )}
      <NavHeaderImgWrapper to={urlPrefix}>
        <Wordmark width="95px" title={t('stockx_logo')} />
      </NavHeaderImgWrapper>
    </NavHeader>
  );
};

export default Header;
